export interface MinimalCertificateData {
  iconSrc: string;
  badge: string;
  header: string;
}

export enum MinimalCertificateDisplayType {
  Eligible = 0,
  Ineligible = 1,
  Inspection = 2,
  FurtherReview = 3,
  FurtherReviewAfterHours = 4,
  Expired = 5,
  NotAvailable = 6,
  GetMyOffer = 7,
}

export interface MinimalCertificateState {
  amount: number;
  offerId: string;
  expirationDate: string;
  isExpired: boolean;
  dealerId: number;
  status: string;
  isEligible: boolean;
  isFurtherReviewNeeded: boolean;
  isInspectionNeeded: boolean;
  isIneligibleOffer: boolean;
  isOfferUnderReview: boolean;
  offerCode: string;
  ineligibleReasons: string;
  isKelleyBuysYourCar: boolean;
  minimalCertificateDisplayType: MinimalCertificateDisplayType;
}

export interface MinimalCertificateBadgeProps {
  text: string;
  color: 'blue' | 'green';
  customStyle?: { [key: string]: string };
}
